import React, { useState, useEffect } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
} from "reactstrap";
import axios from "axios";
const DownAlarm3Modal = ({ isOpen, toggle, onSave, initialData = [] }) => {
  const [rows, setRows] = useState(initialData);

 const [formData, setFormData] = useState([]);
   const [responseMessage, setResponseMessage] = useState("");
   const [allowAddRow, setAllowAddRow] = useState(false);

  // Fetch existing alarms when modal opens
  useEffect(() => {
    if (isOpen) {
      fetchAlarms();
    }
  }, [isOpen]);

 const fetchAlarms = async () => {
  try {
    const res = await axios.get("https://api.hanoch.in/equipment/alarms/?type=6");
    console.log("Fetched alarms:", res); // 👈 check what API returns

    const alarms = res.map((item) => ({
      description: item.description || "",
      actual_tag: item.actual_tag || "",
      datatype: item.datatype || "bool",
      unit: item.unit || "",
      min_value: item.min_value || "",
      max_value: item.max_value || "",
      response_type_one: item.response_type_one ?? 0,
      response_colors_one: item.response_colors_one || "",
      response_type_two: item.response_type_two ?? 1,
      response_colors_two: item.response_colors_two || "",
      submitted: true,
      id: item.id,
      type: 6,
    }));

    console.log("Mapped alarms:", alarms);
    setFormData(alarms);
    setAllowAddRow(true);
  } catch (err) {
    console.error("Error fetching alarms:", err);
  }
};


  // Handle field changes
  const handleParamChange = (index, field, value) => {
    const updated = [...formData];
    updated[index][field] = value;
    setFormData(updated);
  };

  // Add new row
  const handleAddRow = () => {
    setFormData([
      ...formData,
      {
        description: "",
        actual_tag: "",
        datatype: "bool",
        unit: "",
        min_value: "",
        max_value: "",
        response_type_one: 0,
        response_colors_one: "",
        response_type_two: 1,
        response_colors_two: "",
        submitted: false,
        type: 6,
      },
    ]);
    setAllowAddRow(false);
  };

  // Submit new row
  const handleSubmit = async (e, index) => {
    e.preventDefault();
    const row = formData[index];

    try {
      const res = await axios.post("https://api.hanoch.in/equipment/alarms/", row);

    if(res){
          const updated = [...formData];
          updated[index] = { ...row, submitted: true, id: res.id };
          setFormData(updated);
    
          setResponseMessage("Row submitted successfully ✅");
          setAllowAddRow(true);
           fetchAlarms();
           } else {
          setResponseMessage("⚠️ Unexpected response from server");
        }
        } catch (err) {
          setResponseMessage("❌ Error submitting row");
        }
      };
    // Auto clear message after 3 seconds
    useEffect(() => {
      if (responseMessage) {
        const timer = setTimeout(() => setResponseMessage(""), 3000);
        return () => clearTimeout(timer);
      }
    }, [responseMessage]);
    

  // Edit existing row
  const handleEditRow = (index) => {
    const updated = [...formData];
    updated[index].submitted = false;
    setFormData(updated);
    setAllowAddRow(false);
  };

  // Delete row (both API + unsaved)
  const handleDeleteRow = async (index) => {
    const row = formData[index];
    try {
      if (row.id) {
        await axios.delete(`https://api.hanoch.in/equipment/alarms/${row.id}/`);
      }
      const updated = [...formData];
      updated.splice(index, 1);
      setFormData(updated);
    } catch (err) {
      console.error("Error deleting row:", err);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl" >
          <ModalHeader className="bg-light p-3" toggle={toggle}>
           Configuration
          </ModalHeader>
    
          {responseMessage && (
            <div
              className={`alert ${
                responseMessage.includes("Error") ? "alert-danger" : "alert-success"
              }`}
            >
              {responseMessage}
            </div>
          )}
    
          <ModalBody>
            <div className="table-responsive">
              <table className="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Tag</th>
                    <th>Datatype</th>
                     <th>Response Type</th>
                     <th></th>
                     <th></th>
                     <th></th>
                    <th>Unit</th>
                    <th>Min</th>
                    <th>Max</th>
                   
                  
                   
                   
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.map((param, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={param.description}
                          disabled={param.submitted}
                          onChange={(e) =>
                            handleParamChange(index, "description", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={param.actual_tag}
                          disabled={param.submitted}
                          onChange={(e) =>
                            handleParamChange(index, "actual_tag", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <select
                          className="form-select"
                          value={param.datatype}
                          disabled={param.submitted}
                          onChange={(e) =>
                            handleParamChange(index, "datatype", e.target.value)
                          }
                        >
                          <option value="bool">bool</option>
                          <option value="float">float</option>
                          <option value="int">int</option>
                        </select>
                      </td>
                      <td>
      <select
        className="form-select"
        value={param.response_type_one}
        disabled={param.submitted}
        onChange={(e) =>
          handleParamChange(index, "response_type_one", e.target.value)
        }
      >
        <option value="0">0</option>
        <option value="1">1</option>
     
      </select>
    </td>
    <td>
      <select
        className="form-select"
        value={param.response_colors_one}
        disabled={param.submitted}
        onChange={(e) =>
          handleParamChange(index, "response_colors_one", e.target.value)
        }
      >
        <option value="green" style={{ color: "green" }}>🟢 Green</option>
        <option value="red" style={{ color: "red" }}>🔴 Red</option>
        <option value="yellow" style={{ color: "goldenrod" }}>🟡 Yellow</option>
        <option value="blue" style={{ color: "blue" }}>🔵 Blue</option>
      </select>
    </td>
    
    <td>
      <select
        className="form-select"
        value={param.response_type_two}
        disabled={param.submitted}
        onChange={(e) =>
          handleParamChange(index, "response_type_two", e.target.value)
        }
      >
        <option value="0">0</option>
        <option value="1">1</option>
       
      </select>
    </td>
    
    <td>
      <select
        className="form-select"
        value={param.response_colors_two}
        disabled={param.submitted}
        onChange={(e) =>
          handleParamChange(index, "response_colors_two", e.target.value)
        }
      >
        <option value="green">🟢 Green</option>
        <option value="red">🔴 Red</option>
        <option value="yellow">🟡 Yellow</option>
        <option value="blue">🔵 Blue</option>
      </select>
    </td>
                   
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          value={param.unit}
                          disabled={param.submitted}
                          onChange={(e) =>
                            handleParamChange(index, "unit", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={param.min_value}
                          disabled={param.submitted}
                          onChange={(e) =>
                            handleParamChange(index, "min_value", e.target.value)
                          }
                        />
                      </td>
                      <td>
                        <input
                          type="number"
                          className="form-control"
                          value={param.max_value}
                          disabled={param.submitted}
                          onChange={(e) =>
                            handleParamChange(index, "max_value", e.target.value)
                          }
                        />
                      </td>
                     
                      <td>
                        {!param.submitted ? (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={(e) => handleSubmit(e, index)}
                          >
                            Save
                          </button>
                        ) : (
                          <>
          <FaEdit
            className="text-warning me-3"
            style={{ cursor: "pointer" }}
            size={18}
            onClick={() => handleEditRow(index)}
          />
          <FaTrash
            className="text-danger"
            style={{ cursor: "pointer" }}
            size={18}
            onClick={() => handleDeleteRow(index)}
          />
        </>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </ModalBody>
    
          <ModalFooter>
            <button type="button" className="btn btn-light" onClick={toggle}>
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAddRow}
              disabled={!allowAddRow}
            >
              + Add Row
            </button>
          </ModalFooter>
        </Modal>
  );
};
export default DownAlarm3Modal;